<template>
    <div class="container-fluid">
        <div class="row">

            <!-- <SearchView ref="genericSearch" @searchEvent="parentMethod"></SearchView>  -->

            <div class="col-12">
                <div class="card mb-2">
                    <div class="card-header">
                        <h3>List View</h3>
                        <!-- <span class="float-right">
                            <router-link class="btn btn-primary btn-sm rounded-pill" :to="'/modules/'+modules+'/edit'">
                                <i class="fa-solid fa-plus"></i> {{ modules | capitalize }}
                            </router-link>
                        </span> -->
                    </div>
                    <div class="card-body">
                        <template v-if="loading">
                            <loader></loader>
                        </template>
                        <template v-else>
                            <div class="table_responsive">
                                <table cellspacing="0" cellpadding="0" class="table m-0 item_table">
                                    <thead>
                                        <tr>
                                            <th width="30px" v-if="moduleName != 'InstitutionalDocs'">S.No.</th>

                                            <template v-for="(th, index) in tableHead">
                                                <th v-if="th.isSort" @click="sortBy(th.field_name, th.relRef)"
                                                    :class="{ 'sortable': sort.column === th.field_name }" :key="index"
                                                    :style="'width:'+th.width+'px'">
                                                    {{th.label}}
                                                    <span v-if="sort.column === th.field_name" class="sort-icon">
                                                        {{ sort.order === 'asc' ? '▲' : '▼' }}
                                                    </span>
                                                </th>
                                                <th v-else :key="index" :style="'width:'+th.width+'px'">{{th.label}}
                                                </th>
                                            </template>
                                            <!-- 

                                            <th v-for="(column, index) in tableHead" :key="index" :style="'width:'+column.width+'px'"> {{column.label}}</th> -->
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, indexprod) in dataList" :key="indexprod">
                                            <td v-if="moduleName != 'InstitutionalDocs'">{{indexprod+1}}</td>
                                            <td v-for="(column, indexColumn) in tableColumn" :key="indexColumn">
                                                <router-link
                                                    :to="'/modules/'+tableHead[indexColumn].routePath+'/'+item.id+'/detail'"
                                                    v-if="tableHead[indexColumn].link==true">
                                                    <span v-if="column==='status'" class="statusDiv"
                                                        :class="dom_array.listview_statusColor_dom[item.status] ? dom_array.listview_statusColor_dom[item.status] : ''"
                                                         style="white-space: break-spaces;">
                                                        {{item[column]}}
                                                    </span>
                                                    <span v-else  style="white-space: break-spaces;">{{item[column]}}</span>
                                                </router-link>

                                                <router-link
                                                    :to="'/modules/'+tableHead[indexColumn].routePath+'/'+item.parent_id+'/detail'"
                                                    v-else-if="tableHead[indexColumn].linkOtherModule==true">
                                                    <span v-if="column==='status'" class="statusDiv"
                                                        :class="dom_array.listview_statusColor_dom[item.status] ? dom_array.listview_statusColor_dom[item.status] : ''"
                                                        >
                                                        {{item[column]}}
                                                    </span>
                                                    <span v-else>{{item[column]}}</span>
                                                </router-link>

                                                <a href="javascript:void(0)"  v-else-if="tableHead[indexColumn].is_download==true" @click="downloadPrivate(item.id, modules, item.doc_name)" style="word-break: break-all;">
                                                                <i class="fa-solid fa-download"></i>
                                                            </a>
                                                
                                                <template v-else>
                                                    <span v-if="column==='status'" class="statusDiv"
                                                        :class="dom_array.listview_statusColor_dom[item.status] ? dom_array.listview_statusColor_dom[item.status] : ''"
                                                       v-html="item[column]">
                                                    </span>
                                                    <span v-else-if="column ==='description'" v-html="showSubString(item[column])"></span>
                                                    <span v-else v-html="item[column]"></span>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>

                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">

                                <div class="import-file d-flex align-items-center">
                                    <select class="form-select form-select-sm me-2" v-model="selectedOption">
                                        <option value="">Select</option>
                                        <option value="all">All Records</option>
                                        <option value="none">None</option>
                                    </select>
                                    <button class="btn btn-secondary btn-sm" @click="exportData">Export</button>
                                </div>
                            </div>
                            <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">

                                <div class="d-flex justify-content-end align-items-center">
                                    <button :class="pagination.currentPage <= 1 ? 'opacity-50 cursor-not-allowed' : ''"
                                        :disabled="pagination.currentPage <= 1"
                                        class="pagination-link btn btn-secondary btn-sm" type="button"
                                        @click="changePage(pagination.currentPage - 1,tableHead,tableColumn)">
                                        <i class="fa-solid fa-angle-left"></i>
                                    </button>
                                    <span class="mx-2">
                                        <span>{{ (pagination.perPage * pagination.currentPage) - pagination.perPage + 1
                                            }}</span>
                                        {{ $t('to') }}
                                        <span>{{ pagination.perPage * pagination.currentPage <= pagination.total ?
                                                pagination.perPage * pagination.currentPage : pagination.total }}</span>
                                                {{ $t('of') }}
                                                <span>{{ pagination.total }}</span>
                                        </span>
                                        <button
                                            :class="pagination.currentPage >= pagination.totalPages ? 'opacity-50 cursor-not-allowed' : ''"
                                            :disabled="pagination.currentPage >= pagination.totalPages"
                                            class="ml-3 pagination-link btn btn-secondary btn-sm" type="button"
                                            @click="changePage(pagination.currentPage + 1,tableHead,tableColumn)">
                                            <i class="fa-solid fa-angle-right"></i>
                                        </button>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref } from "vue";
    //import SearchView from "@/components/layout/shared/generic/common/SearchView.vue";
    import loader from "@/views/shared/loading/Loading.vue";
    export default {
        name: 'genericList',
        components: {
            //   SearchView,
            loader,
        },
        data() {
            return {
                selectAll: false,
                moduleName:'',
                page: 1,
                search: [],
                sort: {
                    order: 'desc',//desc=asc
                    column: 'date_entered',
                    relRef: '',
                },
                perPage: 10,
                loading: true,
                dataList: [],
                pagination: {
                    currentPage: 0,
                    perPage: 0,
                    total: 0,
                    totalPages: 0
                },
                routePath: null,
                tableHead: [],
                tableColumn: [],
                checked: [],
                modules: null,
                loading: false,
                selectedOption: '',
                records: {},
                checked: {}
            }
        },
        watch: {
            selectAll(value) {
                this.dataList.forEach(item => {
                    this.$set(this.checked, item.id, value)
                })
            }
        },
        mounted() {
            this.dom_array = this.domArrayVariable;
        },
        methods: {
            sortBy(field, relRef) {
                if (this.sort.column === field) {
                    this.sort.order = this.sort.order === 'asc' ? 'desc' : 'asc';
                } else {
                    this.sort.order = 'asc';
                }
                this.sort.column = field;
                this.sort.relRef = relRef;
                this.loadGenericView(this.tableHead, this.tableColumn);
            },
            changePage(page, tableHead, tableColumn) {
                const self = this;
                if ((page > 0) && (page <= self.pagination.totalPages) && (page !== self.page)) {
                    self.page = page;
                    self.loadGenericView(tableHead, tableColumn);
                }
            },
            changeSort() {
                const self = this;
                if (self.sort.order === 'asc') {
                    self.sort.order = 'desc';
                } else if (self.sort.order === 'desc') {
                    self.sort.order = 'asc';
                }
                self.loadGenericView();
            },
            loadGenericView(metaList, columns, searchData = '') {
                const self = this;
                self.loading = true;
                self.tableHead = metaList;
                self.tableColumn = columns;
                self.modules = self.tableHead[0].routePath;
                self.moduleName = self.tableHead[0].moduleName;

                const storedFilters = localStorage.getItem('filters');
                
                if (storedFilters !== null && storedFilters !== '') {
                    self.search = storedFilters;
                }

                if (searchData != '') {
                    self.search = searchData;
                }


                //  let searchaArray = require(`@/views/modules/${this.moduleName}/metaview/metajs/SearchView.js`);
                // self.searchArr = searchaArray;
                //  self.$refs.genericSearch.loadGenericSearch(searchaArray.default);
                axios.get('api/modules/' + self.modules, {
                    params: {
                        page: self.page,
                        sort: self.sort,
                        search: self.search,
                        perPage: self.perPage
                    }
                }).then(function (response) {
                    self.dataList = response.data.items;
                    self.pagination = response.data.pagination;
                    if (self.pagination.totalPages < self.pagination.currentPage) {
                        self.page = self.pagination.totalPages;
                        self.loadGenericView();
                    } else {
                        self.loading = false;
                    }
                }).catch(function () {
                    self.loading = false;
                });
            },
            parentMethod(searchRes) {
                const self = this;
                self.search = searchRes;
                self.loadGenericView(self.tableHead, self.tableColumn);
            },

            exportData() {
                const selectedValues = []
                for (const key in this.checked) {
                    if (this.checked[key]) {
                        selectedValues.push(key)
                    }
                }
                this.records = {
                    module: this.moduleName,
                    ids: selectedValues,
                    callingFrom: 'export',
                    all: this.selectedOption,
                    search: this.search,
                }

                axios.post('api/export', this.records).then(function (response) {
                    var link = document.createElement('a');
                    link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(response.data);
                    link.download = 'data.csv';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }).catch(function () {
                    self.loading = false;
                });
            },

            showSubString(str){
                return str.substring(0, 25)+'.......';
            },

            downloadPrivate(doc_id, tbl,filename) {
            const self = this;
            const token = localStorage.getItem('token');
            if (!token) {
                alert('Please login to download files');
                return;
            }
            
            axios.get(`api/modules/download/${doc_id}/${tbl}`, {
                responseType: 'blob',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                params:{
                    filename:filename
                }
            }).then((response) => {
                //console.log(response);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }).catch((error) => {
                console.error('Download failed:', error);
                self.$refs.notifyMsg.showAlert('Error', 'Download failed. File may not exist or access denied.');
            });
        }
        }
    }
</script>